import { useState, useEffect, useRef } from "react";
import { Form, Dropdown } from "react-bootstrap";

export default function NetworksSelector({
  value = 0,
  onChange,
  networks = [],
  multiple = false,
  defaultText = "",
  isShowTitle = true,
  preventSubmit = false,
}) {
  const holder = useRef();
  const [networkFilter, setNetworkFilter] = useState("");
  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    window.addEventListener("click", ({ target }) => {
      if (holder.current && !holder.current.contains(target)) {
        setIsExpanded(false);
      }
    });
  }, [multiple]);

  const textValue = () => {
    if (value) {
      if (multiple && value.length) {
        return `${value.length} network${value.length === 1 ? "" : "s"} selected`;
      } else {
        const network = networks.find(({ id }) => id === parseInt(value));

        if (network) {
          return network.header.title;
        }
      }
    }

    return defaultText || `Select network${multiple ? "s" : ""}`;
  };

  const onClick = (networkId) => {
    if (!multiple) {
      setIsExpanded(!isExpanded);
    }

    if (onChange) {
      if (multiple) {
        if (networkId === "all") {
          // onChange([]);
          const allIds = networks.map((n) => n.id);
          const isAllSelected = Array.isArray(value) && value.length === networks.length;

          if (isAllSelected) {
            // Deselect all
            onChange([]);
          } else {
            // Select all
            onChange(allIds);
          }
        } else {
          const newValue = [].concat(value);

          if (value.indexOf(networkId) !== -1) {
            newValue.splice(value.indexOf(networkId), 1);
          } else {
            newValue.push(networkId);
          }

          onChange(newValue);
        }
      } else {
        onChange(networkId);
      }
    }
  };

  const isActive = (id) =>
    (multiple && value.indexOf(id) !== -1) || id === parseInt(value);

  return (
    <div className="standard-dropdown">
      {isShowTitle && <div className="standard-dropdown-label">Network:</div>}
      <Dropdown show={isExpanded} ref={holder}>
        <Dropdown.Toggle onClick={() => setIsExpanded(!isExpanded)}>
          {textValue()}
        </Dropdown.Toggle>
        <Dropdown.Menu>
          <Form.Group className="custom-dropdown-search">
            <Form.Control
              name="network-dropdown-search"
              placeholder="Enter network name"
              onChange={({ target }) => setNetworkFilter(target.value)}
              value={networkFilter}
            />
          </Form.Group>
          {multiple ? (
            <Dropdown.Item
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                onClick("all");
              }}
              className="is-underlined"
              as="button"
            >
              <input type="checkbox" onChange={() => {}} />
              Select All
            </Dropdown.Item>
          ) : null}
          {networks
            .filter(
              (network) =>
                !networkFilter ||
                network.header.title
                  .trim()
                  .toLowerCase()
                  .includes(networkFilter.trim().toLowerCase())
            )
            .map((network) => (
              <Dropdown.Item
                key={network.id}
                onClick={(e) => {
                  onClick(network.id);
                  preventSubmit && e.preventDefault();
                }}
                className={isActive(network.id) ? "is-active-option" : ""}
                as="button"
              >
                {multiple ? (
                  <input
                    type="checkbox"
                    checked={isActive(network.id)}
                    onChange={() => {}}
                  />
                ) : null}
                {network.header.title}
              </Dropdown.Item>
            ))}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
}
